import React from "react";
import { Badge, Box, Card, Cell, Layout, Text, Tooltip, TableColumn, Table } from "@wix/design-system";
import "@wix/design-system/styles.global.css";
import { IWixProduct } from "../../../../services/models/types/wixProduct.types";
import { useWixCollectionProducts } from "../../../../hooks/wix/useWix";
import Loading from "../../../common/Loader";
import { truncateText } from "../../../../services/utils/productUtils";
import WixLogo from "../../../../dashboard/pages/wix_logo.svg";
import FiareLogo from "../../../../dashboard/pages/fiare_logo.svg";
import Picture from "../../../../dashboard/images/no-image.png";

const WixCollectionProductRowDetail = (collectionId: any) => {
  collectionId = collectionId.collectionId;
  const wixProductQuery = useWixCollectionProducts({
    collectionId,
  });
  const wixProducts = wixProductQuery.data?.data;
  const columns: TableColumn<IWixProduct>[] = [
    {
      title: "",
      width: "8%",
      render: (row) => (
        <Layout>
          <Cell span={3}>
            <Box width="80px" height="80px" overflow="hidden">
              {row.thumbnail ? <img src={row.thumbnail} /> : <img src={Picture} />}
            </Box>
          </Cell>
        </Layout>
      ),
    },
    {
      title: "Products",
      width: "22%",
      render: (row) => (
        <Layout>
          <Cell span={9}>
            <Tooltip className="tooltip_div" content={row.name}>
              <Text
                style={{
                  fontSize: "14px ",
                  lineHeight: "18px",
                }}
                weight="bold"
              >
                {truncateText(row.name, 30)}
              </Text>
            </Tooltip>
            <>
              <br />
              {row.sku ? <Text size="tiny">SKU:{row.sku}</Text> : <Text size="tiny">Total SKU:{row.total_sku}</Text>}
              <br />
            </>
            <Badge size="tiny" skin={row.visible ? "success" : "neutralLight"}>
              {row.visible ? "Visible" : "Invisible"}
            </Badge>
          </Cell>
        </Layout>
      ),
    },
    {
      title: "Price",
      width: "12%",
      render: (row) => <Text size="small">{row.formattedPrice}</Text>,
    },
    {
      title: "Inventory",
      width: "10%",
      render: (row) => (
        <>
          {row.trackInventory
            ? `${row.quantity} in stock ${
                row.numberOfVariants > 0
                  ? row.numberOfVariants > 1
                    ? `for ${row.numberOfVariants} variants`
                    : `for ${row.numberOfVariants} variant`
                  : ""
              }`
            : row.inStock
            ? "In Stock"
            : "Out of stock"}
        </>
      ),
    },
    {
      title: "View on",
      width: "10%",
      render: (row) => (
        <>
          <Layout>
            <Cell span={4}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                  alignItems: "center",
                }}
              >
                <Tooltip appendTo="window" content="View this product on dashboard">
                  <a href={row.details_url} target="_blank">
                    <img width="32px" height="12px" src={WixLogo} />
                  </a>
                </Tooltip>
                {row.exported_faire_product_id || row.faire_product_id ? (
                  <div style={{ width: "50%" }}>
                    <Tooltip appendTo="window" content="View this product on Faire dashboard">
                      <a
                        href={
                          row.exported_faire_product_id
                            ? row.faire_details_url
                            : `https://www.faire.com/brand-portal/my-shop/products/${row.faire_product_id}`
                        }
                        target="_blank"
                      >
                        <img src={FiareLogo} />
                      </a>
                    </Tooltip>
                  </div>
                ) : (
                  <div style={{ width: "50%" }}> &nbsp;</div>
                )}
              </div>
            </Cell>
          </Layout>
        </>
      ),
    },
  ];
  return (
    <>
      <Card showShadow hideOverflow>
        <Table data={wixProducts} columns={columns}>
          {wixProductQuery.isFetching ? (
            <Loading title="Fetching Wix category products" />
          ) : wixProducts?.length ? (
            <Table.Content />
          ) : (
            ""
          )}
        </Table>
      </Card>
    </>
  );
};
export default WixCollectionProductRowDetail;
